<template>
  <div ref="el" />
</template>

<script lang="ts" setup>
import { ref, onMounted, onUnmounted } from 'vue';

const emit = defineEmits(['intersect']);

const el = ref(null);
const observer = ref(null);

onMounted(() => {
  observer.value = new IntersectionObserver(([entry]) => {
    if (entry && entry.isIntersecting) {
      emit('intersect');
    }
  });

  observer.value.observe(el.value);
});

onUnmounted(() => {
  observer.value.disconnect();
});
</script>

